module.exports = __webpack_public_path__ + "img/2.dac5a8f5.jpg";